<template>
    <action>
        <template slot="header">
            E-Mail Filter <span class="text-red-500" v-show="!saved">Ungespeichert</span>
        </template>
        <p>
            Registrierungen über diese E-Mail Domains sind zugelassen:
        </p>

        <ul class="mb-4">
            <li class="font-bold" v-show="filter.length === 0">Alle</li>
            <li v-for="(domain, index) in filter">
                <div class="flex">
                    <!--<label for="company_website" class="block text-sm font-medium leading-5 text-gray-700">
                        Company Website
                    </label>-->
                    <div class="mt-1 flex rounded-md shadow-sm">
                        <div
                            class="flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                            @
                        </div>
                        <input v-model="filter[index]"
                               class="form-input block w-full px-3 py-2 rounded-none rounded-r-md sm:text-sm sm:leading-5"
                               placeholder="example.com"/>
                    </div>
                    <button class="flex-grow-0 px-2" @click="filter.splice(index,1)">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>

            </li>
        </ul>
        <button-secondary @click="addDomain" type="button">
            <i class="fa fa-plus"></i> Neue Domain
        </button-secondary>
        <template slot="action">
            <button-primary @click="save">
                <i class="fa fa-save"></i> Speichern
            </button-primary>
        </template>
    </action>
</template>

<script>
import ButtonPrimary from "../UI/ButtonPrimary";
import Action from "../UI/Action";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import isEqual from "lodash/isEqual";
import ButtonSecondary from "../UI/ButtonSecondary";

export default {
    name: "MailFilter",
    components: {Action, ButtonPrimary, ButtonSecondary},
    inject: ['group'],

    data: () => ({
        filter: [],
    }),

    created() {
        this.filter = cloneDeep(this.mail_filter);
    },

    computed: {
        mail_filter() {
            return this.group.mail_filter;
        },
        saved() {
            return isEqual(sortBy(this.filter), sortBy(this.mail_filter))
        },
    },

    methods: {
        save() {
            this.loading = true;
            window.axios.post('/admin/group', {
                mail_filter: this.filter,
            }).then((response) => {
                location.reload();
            }).catch((error) => {
                location.reload();
            })
        },
        addDomain() {
            this.filter.push("");
        }
    }
}
</script>

<style scoped>

</style>
